import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { ButtonComponent } from 'src/app/components/button/button.component';

@Component({
  selector: 'app-global-configurations',
  templateUrl: './global-configurations.component.html',
  styleUrls: ['./global-configurations.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatExpansionModule, ButtonComponent],
})
export class GlobalConfigurationsComponent {
  public isTrustedDomainsExpanded = true;
  public isEndpointFilteringExpanded = false;
}
